import { Typography } from '@material-ui/core';

interface LambdaDefaultsHeaderProps {
  title?: string;
  description?: string;
}

export const LambdaDefaultsHeader = ({
  title = 'Default Values',
  description = 'These defaults will be applied if no value is supplied',
}: LambdaDefaultsHeaderProps) => {
  return (
    <div style={{ flex: 1 }}>
      <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          color="textSecondary"
          style={{ fontSize: '0.75rem', marginTop: 4 }}
        >
          {description}
        </Typography>
      )}
    </div>
  );
};
